/**
 * L2-R5: moved verbatim from @shared/models/folders/helpers/mat-tree-helpers.
 * That host path is now a re-export shim of this file.
 */
import { Folder } from './folder.model';

export const hasNoContent = (_: number, _nodeData: Folder) => !_nodeData['name'];
